
// dunya ambalaj screens
import screenShot1 from './dunya_ambalaj_screens/Screenshot 2024-07-19 142638.png'
import screenShot2 from './dunya_ambalaj_screens/Screenshot 2024-07-19 142651.png'
import screenShot3 from './dunya_ambalaj_screens/Screenshot 2024-07-19 142705.png'
import screenShot4 from './dunya_ambalaj_screens/Screenshot 2024-07-19 142818.png'
import screenShot5 from './dunya_ambalaj_screens/Screenshot 2024-07-19 142834.png'
import screenShot6 from './dunya_ambalaj_screens/Screenshot 2024-07-19 142843.png'

// borcumne screens
import borcumNeS1 from './borcumne_screens/Screenshot 2024-07-16 163640.png';
import borcumNeS2 from './borcumne_screens/Screenshot 2024-07-16 163841.png';
import borcumNeS3 from './borcumne_screens/Screenshot 2024-07-16 163917.png';
import borcumNeS4 from './borcumne_screens/Screenshot 2024-07-16 163928.png';
import borcumNeS5 from './borcumne_screens/Screenshot 2024-07-16 163942.png';
import borcumNeS6 from './borcumne_screens/Screenshot 2024-07-16 163958.png';
import borcumNeS7 from './borcumne_screens/Screenshot 2024-07-16 164031.png';
import borcumNeS8 from './borcumne_screens/Screenshot 2024-07-16 164108.png';
import borcumNeS9 from './borcumne_screens/Screenshot 2024-07-16 164129.png';
import borcumNeS10 from './borcumne_screens/Screenshot 2024-07-16 164146.png';
import borcumNeS11 from './borcumne_screens/Screenshot 2024-07-16 164203.png';
import borcumNeS12 from './borcumne_screens/Screenshot 2024-07-16 164220.png';
import borcumNeS13 from './borcumne_screens/Screenshot 2024-07-16 164231.png';
import borcumNeS14 from './borcumne_screens/Screenshot 2024-07-16 164258.png';
import borcumNeS15 from './borcumne_screens/Screenshot 2024-07-16 164413.png';
import borcumNeS16 from './borcumne_screens/Screenshot 2024-07-16 164428.png';
import borcumNeS17 from './borcumne_screens/Screenshot 2024-07-16 164436.png';
import borcumNeS19 from './borcumne_screens/Screenshot 2024-07-16 164453.png';
import borcumNeS18 from './borcumne_screens/Screenshot 2024-07-16 164509.png';
import borcumNeS20 from './borcumne_screens/Screenshot 2024-07-16 164834.png';



// fly to school screens
import flyToSchool1 from './fly_to_school/fly_to_school1.webp'
import flyToSchool2 from './fly_to_school/fly_to_school2.webp'
import flyToSchool3 from './fly_to_school/fly_to_school3.webp'
import flyToSchool4 from './fly_to_school/fly_to_school4.webp'

// html,css,js project screens
import htmlCssJs1 from './html_projects_screens/calculator.png'
import htmlCssJs2 from './html_projects_screens/chat_bot.png'
import htmlCssJs3 from './html_projects_screens/gussing_game.png'
import htmlCssJs4 from './html_projects_screens/hang_man.png'
import htmlCssJs5 from './html_projects_screens/math_game.png'
import htmlCssJs6 from './html_projects_screens/movie_app.png'
import htmlCssJs7 from './html_projects_screens/pomodoro.png'
import htmlCssJs8 from './html_projects_screens/quote.png'
import htmlCssJs9 from './html_projects_screens/quran_app.png'
import htmlCssJs10 from './html_projects_screens/tik-tak.png'
import htmlCssJs11 from './html_projects_screens/to_do_app.png'
import htmlCssJs12 from './html_projects_screens/weather_app.png'


// python project screens
import python1 from './python_projects/dictionary.png'
import python2 from './python_projects/math_game.png'
import python3 from './python_projects/to_do.png'
import python4 from './python_projects/translator.png'
import python5 from './python_projects/vocab_quiz.png'

// react project screens
import react1 from './react_project_screens/pomodoro_app.png'
import react2 from './react_project_screens/to_do.png'
import react3 from './react_project_screens/sweet_savor.png'


export const reactProjects = [
    {
        name: 'Pomodoro App',
        img: react1
    },
    {
        name: 'To Do App',
        img: react2
    },
    {
        name: 'Sweet Savor',
        img: react3
    }
]

export const pythonProjects = [
    {
        name: 'Dictionary',
        img: python1
    },
    {
        name: 'Math Game',
        img: python2
    },
    {
        name: 'To Do App',
        img: python3
    },
    {
        name: 'Translator',
        img: python4
    },
    {
        name: 'Vocab Quiz',
        img: python5
    }
]



export const htmlCssJsProjects = [
    {
        name: 'Calculator',
        img: htmlCssJs1
    },
    {
        name: 'Chat Bot',
        img: htmlCssJs2
    },
    {
        name: 'Gussing Game',
        img: htmlCssJs3
    },
    {
        name: "Hangman",
        img: htmlCssJs4
    },
    {
        name: 'Math Quiz Game',
        img: htmlCssJs5
    },
    {
        name: 'Movie App',
        img: htmlCssJs6
    },
    {
        name: 'Pomodoro Timer',
        img: htmlCssJs7
    },
    {
        name: 'Quote App',
        img: htmlCssJs8
    },
    {
        name: 'Quran App',
        img: htmlCssJs9
    },
    {
        name: 'Tik-Tak',
        img: htmlCssJs10
    },
    {
        name: 'To Do App',
        img: htmlCssJs11
    },
    {
        name: 'Weather App',
        img: htmlCssJs12
    }
]


export const flyToSchoolScreens = [flyToSchool1, flyToSchool2, flyToSchool3, flyToSchool4];


export const borcumNeScreens = [borcumNeS1, borcumNeS2, 
    borcumNeS3, borcumNeS4, borcumNeS5, 
    borcumNeS6, borcumNeS7, borcumNeS8, 
    borcumNeS9, borcumNeS10, borcumNeS11, 
    borcumNeS12, borcumNeS13, borcumNeS14, 
    borcumNeS15, borcumNeS16, borcumNeS17, 
    borcumNeS18, borcumNeS19, borcumNeS20];





export const dunyaAmbalajScreens = [screenShot1,
    screenShot2,
    screenShot3,
    screenShot4,
    screenShot5,
    screenShot6];

